import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=47b1d97f"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"
import style0 from "./Queue.vue?vue&type=style&index=0&id=47b1d97f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports